import api from './api';

const campaignsService = {
  async list(params = {}) {
    const qs = new URLSearchParams();
    const p = params && typeof params === 'object' ? params : {};
    Object.entries(p).forEach(([k, v]) => {
      if (v === undefined || v === null || v === '') return;
      qs.set(k, String(v));
    });
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return api.get(`/api/campaigns${suffix}`);
  },
  async get(id) {
    return api.get(`/api/campaigns/${id}`);
  },
  async create(payload) {
    return api.post('/api/campaigns', payload);
  },
  async update(id, payload) {
    return api.put(`/api/campaigns/${id}`, payload);
  },
  async remove(id) {
    return api.delete(`/api/campaigns/${id}`);
  },
  async addMessage(id, payload) {
    return api.post(`/api/campaigns/${id}/messages`, payload);
  },
  async addRecipients(id, payload) {
    return api.post(`/api/campaigns/${id}/recipients`, payload);
  },
  async start(id) {
    return api.post(`/api/campaigns/${id}/start`);
  },
  async pause(id) {
    return api.post(`/api/campaigns/${id}/pause`);
  },
  async cancel(id) {
    return api.post(`/api/campaigns/${id}/cancel`);
  }
};

export default campaignsService;
